import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'GOLFHOTEL',
  analyticsName: 'Golf',
  queryKey: 'f_golf',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const isGolfHotel = hotel?.isGolfHotel;

    if (isGolfHotel) {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.TRUE,
        bucketName: 'golfcourt',
      };
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'golfcourt',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
